import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import {
  getJobSettingsState,
  getJackState,
  getLeftHipState,
  getRightHipState,
} from '../../../../../store/selectors'
import { jackActions, leftHipActions, rightHipActions } from '../../../../../store/slices'

import Truss from './Truss'

import { isIncludes } from '../../../../../common/fns'
import { CARRIED_MEMBER } from '../../../../../common/constants'

import { RenderIf } from '../../../../../../../utils/fns'

const MultiTruss = (props) => {
  const configuration = useSelector((state) => getJobSettingsState(state).configuration)
  return (
    <React.Fragment>
      {RenderIf(
        isIncludes('center', configuration),
        <Truss
          label={CARRIED_MEMBER.JACK}
          memberName="Jack"
          selector={getJackState}
          actions={jackActions}
          configuration={configuration}
          {...props}
        />,
      )}
      {RenderIf(
        isIncludes('left', configuration),
        <Truss
          label={CARRIED_MEMBER.LEFT_HIP}
          memberName="Left Hip"
          selector={getLeftHipState}
          actions={leftHipActions}
          configuration={configuration}
          {...props}
        />,
      )}
      {RenderIf(
        isIncludes('right', configuration),
        <Truss
          label={CARRIED_MEMBER.RIGHT_HIP}
          memberName="Right Hip"
          selector={getRightHipState}
          actions={rightHipActions}
          configuration={configuration}
          {...props}
        />,
      )}
    </React.Fragment>
  )
}

MultiTruss.propTypes = {
  country: PropTypes.string.isRequired,
}

export default memo(MultiTruss)
